import React from 'react'
import styled from 'styled-components'

import header from '@/assets/images/sdk-header@3x.gif'

const Container = styled.div`
  display: flex;
`

const Image = styled.img`
  padding: 30px;
  height: 480px;
  align-self: center;
`

export const Header: React.FC = ({ children }) => (
  <Container>
    <div>{children}</div>
    <Image src={header} />
  </Container>
)
